import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store"
import {Complaint} from "@/interfaces/entity";

import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {ComplaintParams} from "@/modules/complaint/params";
import {createComplaint, listComplaint, singleComplaint, updateComplaint} from "@/modules/complaint/services";
import {ComplaintState} from "@/interfaces/state";

@Module({dynamic: true, name: "complaint", store})
class ComplaintModule extends VuexModule implements ComplaintState {
    data: IdMapper<Complaint> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: ComplaintParams = new ComplaintParams();

    get complaints() {
        return this.ids.map((id: number) => this.data[id]);
    }

    @Mutation
    private UPDATE_COMPLAINT_PARAMS(payload: any) {
        this.params = payload
    }

    @Mutation
    private MAP_COMPLAINT(payload: any) {
        const idMapper: IdMapper<Complaint> = {};
        this.meta = payload.meta;
        this.ids = payload.datas.map((complaint: Complaint) => {
            idMapper[complaint.id] = {...complaint, isDeleting: false};
            return complaint.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private ADD_COMPLAINT(payload: Complaint) {
        if (!payload || this.ids.includes(payload.id) || this.data[payload.id]) return;
        this.ids = [...this.ids, payload.id];
        this.data = {...this.data, [payload.id]: {...payload, isDeleting: false}}
    }

    @Mutation
    private UPDATE_COMPLAINT(payload: Complaint) {
        if(!this.data[payload.id] || !this.ids.includes(payload.id)) return;
        this.data[payload.id] = { ...payload, isDeleting: false}
    }

    @Action({rawError: true})
    public async createComplaint(form: any) {
        const { data } = await createComplaint(form);
        this.ADD_COMPLAINT(data.data);
    }

    @Action( {rawError: true})
    public async listComplaint(params: ComplaintParams = new ComplaintParams()) {
        const { data } = await listComplaint(params);
        this.MAP_COMPLAINT(data);
    }

    @Action({rawError: true})
    public async singleComplaint(id: number) {
        const { data } = await singleComplaint(id);
        return data.data;
    }

    @Action
    public updateComplaintParams(payload: any) {
        this.UPDATE_COMPLAINT_PARAMS(payload)
    }

    @Action({ rawError: true})
    public async updateComplaint(dataReq: any) {
        const { data } = await updateComplaint(dataReq.id, dataReq)
        this.UPDATE_COMPLAINT(data.data)
    }
}
export const ComplaintStore = getModule(ComplaintModule)
